import { all, call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import {
    cancelUpdates, deleteDevicePackages, fetchLog,
    fetchVersions, findPin,
    findSupportDevices, findSupportDevicesUpdated, requestDeviceCsv,
    requestDeviceLogs,
    updateDevice, updateDeviceNew, updateDevicePhoneInformation
} from '../../../../api/devices/devices.api';
import { SERVER_ERRORS } from '../../../../api/SERVER_ERRORS';
import notifications from '../../notification/actions';
import actions from './actions';
import deviceUpdateActions from '../../../redux/updatePackages/actions'
import {getDeviceType} from "../../deviceVersion/selectors";
function* fetchDevices(payload) {
    try {
        const isKarieDUO = yield select(getDeviceType);
        const params = {
            ...payload.search,
            isKarieDUO
        }
        const response = yield call(findSupportDevices, params ? params : {});
        if (response.devices) {
            yield put({
                type: actions.FETCH_SUPPORT_DEVICES_SUCCESS,
                devices: response.devices,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_SUPPORT_DEVICES_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_SUPPORT_DEVICES_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* fetchVersionsForDevices(payload) {
    try {
        const isKarieDUO = yield select(getDeviceType);
        const response = yield call(fetchVersions, { type: payload.version_type, currentVersion: payload.current_version, limit: 10, isDeviceTypeKarieDUO: isKarieDUO });
        const responseForLauncher = yield call(fetchVersions, { type: "KARIE_LAUNCHER", currentVersion: "0.0.0", limit: 10, isDeviceTypeKarieDUO: isKarieDUO });
        const responseForInstaller = yield call(fetchVersions, { type: "KARIE_INSTALLER", currentVersion: "0.0.0", limit: 10, isDeviceTypeKarieDUO: isKarieDUO });
        if (response.versions) {
            yield put({
                type: actions.FETCH_SUPPORT_DEVICE_FIRMWARE_VERSION_SUCCESS,
                firmwareVersions: response.versions.sort(compareKarieVersion),
                launcherVersions: responseForLauncher.versions.sort(compareKarieVersion),
                installerVersions: responseForInstaller.versions.sort(compareKarieVersion),
            });
        }
        else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_SUPPORT_DEVICE_VERSIONS_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_SUPPORT_DEVICE_VERSIONS_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* fetchDeviceLog(payload) {
    try {
        const response = yield call(fetchLog, payload.id);
        if (!response) {
            yield put({
                type: actions.FETCH_SUPPORT_DEVICE_LOG_SUCCESS,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_SUPPORT_DEVICE_LOG_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_SUPPORT_DEVICE_LOG_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* requestLogs(payload) {
    try {
        const response = yield call(requestDeviceLogs, payload.id, payload.startDate, payload.endDate, payload.logFile, payload.dispenseImage);
        if (response.updated === "OK") {
            yield put({
                type: actions.REQUEST_SUPPORT_LOG_SUCCESS,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.REQUEST_SUPPORT_LOG_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.REQUEST_SUPPORT_LOG_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* fetchDeviceCsv(payload) {
    try {
        const isKarieDUO = yield select(getDeviceType);
        const params = {
            ...payload.search,
            isKarieDUO
        }
        const response = yield call(requestDeviceCsv, params ? params : {});
        if (!response) {
            yield put({
                type: actions.DOWNLOAD_DEVICE_CSV_SUCCESS,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.DOWNLOAD_DEVICE_CSV_ERROR,
            }));
        }
    } catch (error) {
        console.log("errors", error)
        yield put(notifications.createNotification({
            mainAction: actions.DOWNLOAD_DEVICE_CSV_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

/**
 * Adaptation of https://github.com/substack/semver-compare
 * 
 * @param {KarieVersion} a first version for comparison
 * @param {KarieVersion} b second version b for comparison
 */
function compareKarieVersion(a, b) {
    const pa = a.number.split(".");
    const pb = b.number.split(".");
    for (var i = 0; i < 3; i++) {
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (!isNaN(na) && isNaN(nb)) return -1;
        if (isNaN(na) && !isNaN(nb)) return 1;
        if (na > nb) return -1;
        if (nb > na) return 1;
    }
    return 0;
}

function* fetchVersionsForType(payload) {
    try {
        const isKarieDUO = yield select(getDeviceType);
        const response = yield call(fetchVersions, { type: payload.version_type, currentVersion: payload.current_version, limit: 10, isDeviceTypeKarieDUO: isKarieDUO });
        if (response.versions) {
            yield put({
                type: actions.FETCH_SUPPORT_DEVICE_VERSIONS_SUCCESS,
                versions: response.versions.sort(compareKarieVersion),
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_SUPPORT_DEVICE_VERSIONS_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_SUPPORT_DEVICE_VERSIONS_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* startUpdateDevicePhoneInfo(payload) {
    try {
        const response = yield call(updateDevicePhoneInformation, { deviceId: payload.deviceId, SIMNumber: payload.SIMNumber, IMEI: payload.IMEI, clearToken: payload.clearToken });
        if (response.updated === "OK") {
            yield put(notifications.createNotification({
                message: "Successfully set device to be updated.",
                status: "SUCCESS",
                mainAction: actions.REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE_SUCCESS,
            }));
        } else {
            if (response[0].code === SERVER_ERRORS.COULD_NOT_SET_DEVICE_UPDATE) {
                yield put(notifications.createNotification({
                    message: response[0].message,
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_UPDATE_ERROR,
                }));
            } else {
                yield put(notifications.createNotification({
                    ...response[0],
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE_ERROR,
                }));
            }
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* startUpdate(payload) {
    try {
        const isKarieDUO = yield select(getDeviceType);
        let response
        if (!payload.totalItems) {
            response = yield call(updateDevice, { deviceIds: payload.deviceIds, versionId: payload.versionId, type: payload.version_type, updatePackageId: payload.updatePackageId });
        }
        else if (payload.totalItems) {
            response = yield call(updateDeviceNew, { deviceIds: payload.deviceIds, versionId: payload.versionId, type: payload.version_type, updatePackageId: payload.updatePackageId, search: payload.search, totalItems: payload.totalItems, isKarieDUO: isKarieDUO });
        }
        if (response.updated === "OK") {
            if (typeof response.devices === "number") {
                let resultStr = ''
                if (response.devices === 0) {
                    resultStr = 'Congratulations! All the devices have been updated to your assigned package.'
                }
                else if (response.devices !== 0) {
                    resultStr = `There are ${response.devices} out of ${payload.totalItems} devices updated successfully.`
                }
                yield put(notifications.createNotification({
                    message: resultStr,
                    status: "SUCCESS",
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_UPDATE_SUCCESS,
                }));
            }
            else {
                yield put(notifications.createNotification({
                    message: "Successfully set device to be updated.",
                    status: "SUCCESS",
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_UPDATE_SUCCESS,
                }));
            }
        } else {
            if (response[0].code === SERVER_ERRORS.CANNOT_SET_UPDATE) {
                yield put(notifications.createNotification({
                    message: response[0].message,
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_UPDATE_ERROR,
                }));
            } else {
                yield put(notifications.createNotification({
                    ...response[0],
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_UPDATE_ERROR,
                }));
            }
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.REQUEST_SUPPORT_DEVICE_UPDATE_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}
function* startDelete(payload) {
    try {
        const response = yield call(deleteDevicePackages, { packageId: payload.packageId });
        if (response.deleted === "OK") {
            yield put({type: deviceUpdateActions.FETCH_UPDATE_PACKAGES});
            yield put(notifications.createNotification({
                message: "Successfully delete the package.",
                status: "SUCCESS",
                mainAction: actions.REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_SUCCESS,
            }));
        } else {
            if (response[0].code === SERVER_ERRORS.COULD_NOT_FOUND_PACKAGE) {
                yield put(notifications.createNotification({
                    message: response[0].message,
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_ERROR,
                }));
            }
            else if (response[0].code === SERVER_ERRORS.COULD_NOT_DELETE_UPDATE_PACKAGE_RECORD) {
                yield put(notifications.createNotification({
                    message: response[0].message,
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_ERROR,
                }));
            }
            else {
                yield put(notifications.createNotification({
                    ...response[0],
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_ERROR,
                }));
            }
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}
function* cancelDevicesUpdate(payload) {
    try {
        const response = yield call(cancelUpdates, { deviceIds: payload.deviceIds });
        if (response.updated === "OK") {
            yield put(notifications.createNotification({
                message: "Successfully canceled updated.",
                status: "SUCCESS",
                mainAction: actions.REQUEST_SUPPORT_DEVICE_CANCEL_SUCCESS,
            }));
        } else {
            if (response[0].code === SERVER_ERRORS.CANNOT_SET_UPDATE) {
                yield put(notifications.createNotification({
                    message: response[0].message,
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_CANCEL_ERROR,
                }));
            } else {
                yield put(notifications.createNotification({
                    ...response[0],
                    mainAction: actions.REQUEST_SUPPORT_DEVICE_CANCEL_ERROR,
                }));
            }
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.REQUEST_SUPPORT_DEVICE_CANCEL_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* fetchDevicesUpdated(payload) {
    try {
        const isKarieDUO = yield select(getDeviceType);
        const params = {
            ...payload.search,
            isKarieDUO
        }
        const response = yield call(findSupportDevicesUpdated, params ? params : {});
        if (response.devices) {
            yield put({
                type: actions.FETCH_SUPPORT_DEVICES_UPDATED_SUCCESS,
                devices: response.devices,
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_SUPPORT_DEVICES_UPDATED_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_SUPPORT_DEVICES_UPDATED_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

function* fetchPin(payload) {
    const isKarieDUO = yield select(getDeviceType);
    try {
        const params = {
           ...payload.payload,
           isKarieDUO,
        };
        if (!isKarieDUO) {
            yield put({
                type: actions.FETCH_EXIT_KIOSK_PIN_SUCCESS,
                devices: null,
            });
            return;
        }
        const response = yield call(findPin, params ? params : {});
        if (response.devices) {
            yield put({
                type: actions.FETCH_EXIT_KIOSK_PIN_SUCCESS,
                devices: response.devices,
            });
        }
        else {
            yield put({
                type: actions.FETCH_EXIT_KIOSK_PIN_SUCCESS,
                devices: null,
            });
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_EXIT_KIOSK_PIN_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.FETCH_SUPPORT_DEVICES, fetchDevices),
        takeEvery(actions.FETCH_SUPPORT_DEVICES_UPDATED, fetchDevicesUpdated),
        takeLatest(actions.FETCH_SUPPORT_DEVICE_LOG, fetchDeviceLog),
        takeLatest(actions.REQUEST_SUPPORT_DEVICE_UPDATE, startUpdate),
        takeLatest(actions.REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE, startDelete),
        takeLatest(actions.REQUEST_SUPPORT_DEVICE_CANCEL, cancelDevicesUpdate),
        takeLatest(actions.REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE, startUpdateDevicePhoneInfo),
        takeLatest(actions.FETCH_SUPPORT_DEVICE_VERSIONS, fetchVersionsForType),
        takeEvery(actions.FETCH_SUPPORT_DEVICE_FIRMWARE_VERSIONS, fetchVersionsForDevices),
        takeLatest(actions.REQUEST_SUPPORT_LOG, requestLogs),
        takeLatest(actions.DOWNLOAD_DEVICE_CSV, fetchDeviceCsv),
        takeLatest(actions.FETCH_EXIT_KIOSK_PIN, fetchPin),
    ]);
}
